import Defs from '../../../../includes/primitives/colorDefs'

export default {
  data: () => ({

    Area_Canvas: null,
    rawData: null,

    radar: null,
    title: null,
    grids: null,
    axes: null,
    series: null,
    value: null,
    legends: null,
    
  }),

  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },

  methods: {

    set_Gradients() {
      Defs.set_Gradients(this.svg, this.localId, 'LinearA4', this.radar.color)
    },
  
  }
}